import { createAction } from '@reduxjs/toolkit';

export const setErrors = createAction('user/setAuthErrors');